import { render } from '@wordpress/element';
import App from './App';
import "./Styles.css";

render(<App />, document.getElementById("schema-settings-app"));